import React from 'react';
import { Box, TextInput, Group, ActionIcon, Divider } from '@mantine/core';
import { X, Plus } from 'tabler-icons-react';

function WordToNumbersEpreuve({ form, index, onRemove, convertWordToNumber }) {
    const handleInputChange = (e, path) => {
        const value = e.target.value;
        // Only allow letters, spaces, and hyphens
        if (/^[a-zA-Z\s-]*$/.test(value)) {
            form.setFieldValue(path, value);
        }
    };

    return (
        <Box key={index}>
            <TextInput
                placeholder="Écrire le mot à convertir en nombre"
                mb={10}
                radius={10}
                {...form.getInputProps(`epreuves.${index}.titre`)}
                onChange={(e) => handleInputChange(e, `epreuves.${index}.titre`)}
            />
            <Group position="apart">
                <Group>
                    {form.values.epreuves[index].consigne.map((subItem, idx) => (
                        <TextInput
                            key={idx}
                            placeholder="Nombre en lettres"
                            radius={10}
                            w={200}
                            value={form.values.epreuves[index].consigne[idx].value}
                            onChange={(e) => handleInputChange(e, `epreuves.${index}.consigne.${idx}.value`)}
                            onBlur={(e) => {
                                const word = e.target.value.trim().toLowerCase();
                                console.log("word", word);
                                if (word) {
                                    const number = convertWordToNumber(word);
                                    console.log("number", number);
                                    if (number !== null) {
                                        form.setFieldValue(
                                            `epreuves.${index}.correction_dp.${idx}`,
                                            number
                                        );
                                        console.log("form.values.epreuves[index].correction_dp.${idx}", form.values.epreuves[index].correction_dp[idx]);
                                    }
                                }
                            }}
                        />
                    ))}
                    <ActionIcon
                        color="green"
                        onClick={() =>
                            form.insertListItem(`epreuves.${index}.consigne`, { value: "" })
                        }
                    >
                        <Plus size="1rem" />
                    </ActionIcon>
                </Group>
                <ActionIcon color="red" onClick={() => onRemove(index)}>
                    <X size="1rem" />
                </ActionIcon>
            </Group>
            <Divider my={20} />
        </Box>
    );
}

export default WordToNumbersEpreuve; 